<template>
  <div class="bread_container">
    <!-- <a class="reload"   @click="reloads()"><i class="el-icon-refresh"></i>刷新</a> -->
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isActive: false
    };
  },
  // props:["curIndex"]
  // ,
  created() {
    //   console.log("curIndex")
    //   console.log(this.curIndex)
  },
  methods: {
    reloads() {
      // this.reload();

      this.$emit("tableList", this.page.curIndex);
    }
  },
  computed: {
    ...mapState(["page"])
  }
};
</script>

<style scoped>
.bread_container {
  display: inline-block;
  /* padding:10px 0; */
  /* background:#f9f9fb; */
  /* border-bottom:10px solid #eff2f7; */
  /* height:55px; */
}

.reload {
  /* margin: 0px 10px; */
  cursor: pointer;
  color: #67c23a !important;
}
.reload:hover {
  color: rgb(45, 107, 15) !important;
}
.bars .el-icon-menu {
  color: #67c23a !important;
}
</style>


